import {AfterViewInit, Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalQuestionService} from '../../services/global-question.service';
import {slideInRightOnEnterAnimation, slideOutLeftOnLeaveAnimation} from 'angular-animations';
import { UserStore } from 'src/app/modules/authentication/state/user.store';

declare var noUiSlider: any;
declare var wNumb: any;

@Component({
    selector: 'app-check-token',
    templateUrl: './check-token.component.html',
    styleUrls: ['./check-token.component.scss'],
    animations: [
        slideInRightOnEnterAnimation({ duration: 600 }),
        slideOutLeftOnLeaveAnimation()
    ],
    standalone: false
})
export class CheckTokenComponent implements OnInit, AfterViewInit, OnChanges {

  flow: any;
  button: any;
  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private userStore: UserStore,
    public questionService: GlobalQuestionService
  ) {
    this.questionService.spinner(true);
    let person_id = this.userStore.getValue()?.person_id;
    this.route.queryParams.subscribe(params => {
      if (params?.token_id) {
        this.questionService.spinner(true);
        let ip = localStorage.getItem('ip_address') || 0;
        const parameters = new Map<string, string>();
        parameters.set('token_id', params?.token_id.toString());
        parameters.set('person_id', person_id.toString());
        parameters.set('ip_address', ip.toString());
        this.questionService.runCommandNew(`checkToken`, parameters).subscribe(flow => {
          this.flow = flow[0];
          if (this.flow?.status_id === 1){
            this.router.navigateByUrl(this.flow?.url);
          }
          else{
            this.button = JSON.parse(this.flow?.buttons)[0];
          }
          this.questionService.spinner(false);
        })

      }
    })
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  ngAfterViewInit(): void {

  }
  moveOn(): void {
    this.router.navigateByUrl(this.button?.url);
  }

}
